import React, { FC } from 'react'
import { Slider, SliderProps } from '@mui/material'

const EvtSlider: FC<SliderProps> = ({ ...props }) => {
    return <Slider {...props} />
}

export default EvtSlider
